export const getUserAddons = (user) => {
	if (user.addons && user.addons.length > 0) {
		const check = typeof user.addons === 'string';
		return check ? JSON.parse(user.addons) : user.addons;
	}
	return [];
};
